module.exports = __webpack_public_path__ + "img/antes_despues_228.c77453cd.png";